import { useState } from 'react'

import { isNotificationTypeInfo } from '../../../../utils/notification'

export function useCollapsedHeader({ blackList, isFullScreen, notifications }) {
  const [collapsedHeader, setCollapsedHeader] = useState(false)

  const errorNotification = notifications.filter(
    i => !isNotificationTypeInfo(i.type)
  )

  const [prevIsFullScreen, setPrevIsFullScreen] = useState(isFullScreen)
  const [prevErrorNotification, setPrevErrorNotification] =
    useState(errorNotification)
  const [prevBlackList, setPrevBlackList] = useState(blackList)

  // Expands the header when its inputs change, during render
  if (isFullScreen !== prevIsFullScreen) {
    setPrevIsFullScreen(isFullScreen)
    setCollapsedHeader(false)
  }

  if (errorNotification !== prevErrorNotification) {
    setPrevErrorNotification(errorNotification)

    if (errorNotification.length > 0) {
      setCollapsedHeader(false)
    }
  }

  if (blackList !== prevBlackList) {
    setPrevBlackList(blackList)

    if (blackList.length > 0) {
      setCollapsedHeader(false)
    }
  }

  function handleCollapseHeader() {
    if (notifications.length === 0 && blackList.length === 0) {
      setCollapsedHeader(true)
    }
  }

  return {
    collapsedHeader,
    handleCollapseHeader,
    setCollapsedHeader,
  }
}
